import { importDotykackaCatalog } from "app/services/api/integrations";

export const handleImportDotykacka = async ({
  customer,
  setImportOpen,
  setImportProgress,
  enqueueSnackbar,
  t,
}) => {
  const locationCode = customer?.dsokSettings?.customer?.locations?.[1]?.code;
  setImportOpen(true);
  setImportProgress(0);
  let current = 0;
  const interval = setInterval(() => {
    current = Math.min(90, current + Math.floor(Math.random() * 7) + 3);
    setImportProgress((prev) => {
      const next = Math.max(prev ?? 0, current);
      return next > 90 ? 90 : next;
    });
  }, 250);

  const result = await importDotykackaCatalog(locationCode, {
    onDownloadProgress: (e) => {
      if (!e.total) return;
      const percent = Math.round((e.loaded * 100) / e.total);
      setImportProgress(percent);
    },
  });

  if (result?.status === "OK") {
    enqueueSnackbar(t("pages.dsokCustomers.notifications.importSuccessful"), {
      variant: "success",
    });
  } else {
    enqueueSnackbar(t("pages.dsokCustomers.notifications.importFailed"), {
      variant: "error",
    });
  }
  clearInterval(interval);
  setImportProgress(100);
  setTimeout(() => {
    setImportProgress(null);
    setImportOpen(false);
  }, 500);
};
